<template>
  <div class="helpResourceConfig">
    <div class="leftBox">
      <basic-container>
        <el-card class="box-card">
          <div slot="header"
               class="clearfix">
            <span>帮助中心视频教程资源组</span>
          </div>
          <div class="clearfix">
            <avue-crud :option="optionParent"
                       :table-loading="loading"
                       :data="dataParent"
                       :page="pageParent"
                       ref="crud"
                       v-model="formParent"
                       :permission="permissionList"
                       :before-open="beforeOpen"
                       @row-del="rowDel"
                       @row-update="rowUpdate"
                       @row-save="rowSave"
                       @row-click="handleRowClick"
                       @search-change="searchChange"
                       @search-reset="searchReset"
                       @selection-change="selectionChange"
                       @current-change="currentChange"
                       @size-change="sizeChange"
                       @refresh-change="refreshChange"
                       @on-load="onLoadParent">
              <template slot="menuLeft">
                <el-button type="danger"
                           size="small"
                           icon="el-icon-delete"
                           v-if="permission.dict_delete"
                           plain
                           @click="handleDelete">删 除
                </el-button>
              </template>
              <template slot-scope="{row}"
                        slot="isSealed">
                <el-tag>{{row.isSealed===0?'否':'是'}}</el-tag>
              </template>
            </avue-crud>
          </div>
        </el-card>
      </basic-container>
    </div>
    <dragAdjustWidth wrapperBox="helpResourceConfig"></dragAdjustWidth>
    <div class="rightBox">
      <basic-container>
        <el-card class="box-card">
          <div slot="header"
               class="clearfix">
            <span>[{{dictValue}}] 资源配置</span>
          </div>
          <div class="clearfix">
            <avue-crud :option="optionChild"
                       :table-loading="loadingChild"
                       :data="dataChild"
                       ref="crudChild"
                       v-model="formChild"
                       :permission="permissionList"
                       :before-open="beforeOpenChild"
                       @row-del="rowDelChild"
                       @row-update="rowUpdateChild"
                       @row-save="rowSaveChild"
                       @search-change="searchChangeChild"
                       @search-reset="searchResetChild"
                       @selection-change="selectionChangeChild"
                       @current-change="currentChangeChild"
                       @size-change="sizeChangeChild"
                       @refresh-change="refreshChangeChild"
                       @on-load="onLoadChild"
                       @sortable-change="sortableChildChange"
                       :upload-before="uploadBefore"
                        :upload-error="uploadError"
                       >
              <template slot="menuLeft">
                <el-button type="danger"
                           size="small"
                           icon="el-icon-delete"
                           v-if="permission.dict_delete"
                           plain
                           @click="handleDeleteChild">删 除
                </el-button>
                <el-tooltip content="拖动数据可以进行排序!" placement="right">
                  <el-button type="success"
                           size="small"
                           icon="el-icon-check"
                           @click="handleSaveSort">保存排序
                </el-button>
                </el-tooltip>
              </template>
              <template slot="icon" slot-scope="{row}">
                  <el-image v-if="row.icon" :src="row.icon" style="width:100px;height:50px;cursor:pointer;" @click="showImge(row.image)"></el-image>
              </template>
              <template slot="image" slot-scope="{row}">
                  <el-image :src="row.image" style="width:100px;height:50px;cursor:pointer;" @click="showImge(row.image)"></el-image>
              </template>
              <template slot="appidFilterList" slot-scope="{row}">
                <template v-if="row.appidFilterNames">
                    <template v-if="row.appidFilterNames.split(';').length <5 ">
                      <el-tag v-for="(item, index) in row.appidFilterNames.split(';') " :key="index">
                              {{ item}}
                      </el-tag>
                    </template>
                    <template v-else>
                      <el-tag>{{row.appidFilterNames.split(';')[0]}}</el-tag>
                      <el-popover
                        placement="right"
                        width="400"
                        trigger="click">
                        <div>
                          <el-tag size="mini" v-for="(item, index) in row.appidFilterNames.split(';')" :key="index">{{item}}</el-tag>
                        </div>
                        <el-tag size="mini" slot="reference" class="el-icon-right">展开更多</el-tag>
                      </el-popover>
                  </template>
                </template>
              </template>
               <template slot-scope="scope"
                    slot="eventType">
                {{scope.dic.filter(item => [scope.row.eventType+''].includes(item.dictKey))[0].dictValue }}
              </template>
              <template slot-scope="scope"
                        slot="appidFilterListForm">
                <el-input type="textarea"
                          @focus="handleClick()"
                          v-model="formChild.appidFilterNames"> </el-input>
              </template>
              <template slot-scope="{row}"
                        slot="isSealed">
                <el-tag>{{row.isSealed===0?'否':'是'}}</el-tag>
              </template>
            </avue-crud>
          </div>
        </el-card>
        <channel-popups :app-id="formChild.appidFilterList"
                        :visible.sync="activityForm.showPopups"
                        @comfirm="handleConfirm"></channel-popups>
      </basic-container>  
    </div>
  </div>
</template>

<script>
import {
  getAppResourceGroups,
  getResourceChildList,
  AppResourceGroupsRemove,
  AppResourceGroupsSubmit,
  appResourceItemRemove,
  appResourceItemSaveSort,
  appResourceItemSubmit
} from "@/api/desk/notice";
import { optionParent, optionChild } from "./const/helpResourceOption";
import { mapGetters, mapActions } from "vuex";
import AvueUeditor from 'avue-plugin-ueditor';
import ChannelPopups from '@/components/channel-popups';
import dragAdjustWidth from '@/components/dragAdjustWidth'
export default {
  data () {
    return {
      dictValue: '暂无',
      activityForm: {
        appId: '',
        channel: '',
        showPopups: false

      },
      showImage:'',
      sortIds: '',
      parentId: -1,
      formParent: {},
      formChild: {
        appidFilterType: 0
      },
      selectionList: [],
      query: {},
      loading: true,
      loadingChild: true,
      pageParent: {
        pageSize: 10,
        pageSizes: [10, 30, 50, 100, 200],
        currentPage: 1,
        total: 0
      },
      pageChild: {
        pageSize: 10,
        pageSizes: [10, 30, 50, 100, 200],
        currentPage: 1,
        total: 0
      },
      dataParent: [],
      dataChild: [],
      optionParent: optionParent,
      optionChild: optionChild
    };
  },
  watch: {
    'formChild.appidFilterType': {
      handler (v) {
        console.log('[watch.handlerChangeValue]', v)
        let appidFilterList = this.findObject(this.optionChild.column, 'appidFilterList')
        let appidFilterType = this.findObject(this.optionChild.column, 'appidFilterType')
        if (v) {
          appidFilterType.row = false
          appidFilterList.display = true
        } else {
          appidFilterType.row = true
          appidFilterList.display = false
        }
      }
    },
  },
  components: {
    ChannelPopups,
    AvueUeditor,
    dragAdjustWidth
  },
  computed: {
    ...mapGetters(["permission"]),
    permissionList () {
      return {
        addBtn: this.vaildData(this.permission.resourceConfig_add, false),
        delBtn: this.vaildData(this.permission.resourceConfig_delete, false),
        editBtn: this.vaildData(this.permission.resourceConfig_edit, false),
        viewBtn: false,
      };
    },
    ids () {
      let ids = [];
      this.selectionList.forEach(ele => {
        ids.push(ele.id);
      });
      return ids.join(",");
    }
  },
  mounted () {
    console.log('this.$refs.crud.option.column------', this.$refs.crud.option.column)
    this.$refs.crud.option.searchBtn = false  // 搜索
    this.$refs.crud.option.refreshBtn = false // 刷新
    this.$refs.crud.option.columnBtn = false // 显隐
    this.$refs.crud.option.emptyBtn = false // 清空
    this.$refs.crud.option.column.filter(item => {
      if (item.prop === "code") {
        item.search = false
      }
    })
  },
  methods: {
    ...mapActions('runActivityManage', ['clearDicts']),
    uploadBefore(file, done, loading,column) {
      console.log(column,file)
      // var newFile = new File([file], '1234', { type: file.type });
      if(file.size >  500*1000){
          this.$message.success('上传图片过大')
          loading();
      }else{
            done();
      }
    },
    uploadError(error) {
      this.$message.success(error);
    },

    showImge(url){
      this.$alert("<img src='"+url+"' style='width:100%'>" ,'图片展示', {
          dangerouslyUseHTMLString: true,
          showConfirmButton:false,
          customClass:'showImage'
        });
    },
    // 选择渠道
    handleConfirm (data) {
      const { isAll, appId, channel } = data;
      this.formChild.appidFilterList = appId
      this.formChild.appidFilterNames = channel
      if (isAll) {
        this.channel = 1;
        this.activityForm.appId = '';
        this.activityForm.channel = '';
      }
    },
    handleClick () {
      this.activityForm.showPopups = true
    },
    rowSave (row, done, loading) {
      const form = {
        ...row,
        dictKey: -1,
      };
      AppResourceGroupsSubmit(form).then(() => {
        this.onLoadParent(this.pageParent);
        this.$message({
          type: "success",
          message: "操作成功!"
        });
        done();
      }, error => {
        window.console.log(error);
        loading();
      });
    },
    rowUpdate (row, index, done, loading) {
      AppResourceGroupsSubmit(row).then(() => {
        this.onLoadParent(this.pageParent);
        this.$message({
          type: "success",
          message: "操作成功!"
        });
        done();
      }, error => {
        window.console.log(error);
        loading();
      });
    },
    rowDel (row) {
      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          return AppResourceGroupsRemove(row.id);
        })
        .then(() => {
          this.onLoadParent(this.pageParent);
          this.$message({
            type: "success",
            message: "操作成功!"
          });
        });
    },
    handleRowClick (row) {
      this.parentId = row.id;
      this.dictValue = row.name;

      // this.$refs.crudChild.value.code = row.code;
      this.$refs.crudChild.value.parentId = row.id;
      this.$refs.crudChild.option.column.filter(item => {
        if (item.prop === "code") {
          item.value = '';
        }

        if (item.prop === "groupId") {
          item.value = row.id;
        }
      });
      this.onLoadChild(this.pageChild);
    },
    searchReset () {
      this.query = {};
      this.onLoadParent(this.pageParent);
    },
    searchChange (params, done) {
      this.query = params;
      this.pageParent.currentPage = 1;
      this.onLoadParent(this.pageParent, params);
      done();
    },
    selectionChange (list) {
      this.selectionList = list;
    },
    selectionClear () {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    handleDelete () {
      if (this.selectionList.length === 0) {
        this.$message.warning("请选择至少一条数据");
        return;
      }
      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          return AppResourceGroupsRemove(this.ids);
        })
        .then(() => {
          this.onLoadParent(this.pageParent);
          this.$message({
            type: "success",
            message: "操作成功!"
          });
          this.$refs.crud.toggleSelection();
        });
    },
    handleSaveSort () {
      if (this.sortIds.length === 0) {
        this.$message.warning("排序未发生变化！");
        return;
      }
      this.$confirm("确定保存现在排序?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {

        return appResourceItemSaveSort(this.sortIds.toString());
      }).then(() => {
        this.$message({
          type: "success",
          message: "操作成功!"
        });
      });
    },
    beforeOpen (done, type) {
      console.log(type, '打开类型暂时不处理')
      // if (["add"].includes(type)) {
      //   this.formChild.appidFilterType = 0
      // }
      
      // 通过'this.$refs.crud'查找form表单对象后在filter出对象
      this.$refs.crud.option.column.filter(item => {
        if (item.prop === "tags") {
          item.value = 'tv-help'
          item.disabled = true
        }
      });
      done();
    },
    currentChange (currentPage) {
      this.pageParent.currentPage = currentPage;
    },
    sizeChange (pageSize) {
      this.pageParent.pageSize = pageSize;
    },
    refreshChange () {
      this.onLoadParent(this.pageParent, this.query);
    },
    rowSaveChild (row, done, loading) {
      if(row.modAns.length === 0) {
        row.modAns = ''
      }
      if(row.userTags.length === 0) {
        row.userTags = ''
      }
      appResourceItemSubmit(row).then(() => {
        this.onLoadChild(this.pageChild);
        this.$message({
          type: "success",
          message: "操作成功!"
        });
        done();
      }, error => {
        window.console.log(error);
        loading();
      });
    },
    rowUpdateChild (row, index, done, loading) {

      //  row.appidFilterList = this.activityForm.appId
      // console.log(row)
      appResourceItemSubmit(row).then(() => {
        this.onLoadChild(this.pageChild);
        this.$message({
          type: "success",
          message: "操作成功!"
        });
        done();
      }, error => {
        window.console.log(error);
        loading();
      });
    },
    rowDelChild (row) {
      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          return appResourceItemRemove(row.id);
        })
        .then(() => {
          this.onLoadChild(this.pageChild);
          this.$message({
            type: "success",
            message: "操作成功!"
          });
        });
    },
    searchResetChild () {
      this.query = {};
      this.onLoadChild(this.pageChild);
    },
    searchChangeChild (params, done) {
      this.query = params;
      this.pageChild.currentPage = 1;
      this.onLoadChild(this.pageChild, params);
      done();
    },
    selectionChangeChild (list) {
      this.selectionList = list;
    },
    selectionClearChild () {
      this.selectionList = [];
      this.$refs.crudChild.toggleSelection();
    },
    handleDeleteChild () {
      if (this.selectionList.length === 0) {
        this.$message.warning("请选择至少一条数据");
        return;
      }
      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          return appResourceItemRemove(this.ids);
        })
        .then(() => {
          this.onLoadChild(this.pageChild);
          this.$message({
            type: "success",
            message: "操作成功!"
          });
          this.$refs.crudChild.toggleSelection();
        });
    },
    beforeOpenChild (done, type) {
      if (["add"].includes(type)) {

        this.activityForm.channel = ''
        this.activityForm.appId = ''

        setTimeout(() => {
          this.formChild.appidFilterType = 0
          this.formChild.status = 1
        }, 0)
        console.log('[beforeOpenChild]', type, this.formChild)
      } else {
        this.formChild.eventType = this.formChild.eventType+''
        // console.log('[beforeOpenChild]', type, this.formChild.eventType)
        // this.activityForm.appId = this.formChild.appidFilterList
        // this.activityForm.channel = this.formChild.appidFilterNames
      }
      done();
    },
    currentChangeChild (currentPage) {
      this.pageChild.currentPage = currentPage;
    },
    sizeChangeChild (pageSize) {
      this.pageChild.pageSize = pageSize;
    },
    refreshChangeChild () {
      this.onLoadChild(this.pageChild, this.query);
    },
    onLoadParent (page, params = {}) {
      this.loading = true;
      this.query.tag = 'tv-help'
      getAppResourceGroups(
        page.currentPage,
        page.pageSize,
        Object.assign(params, this.query)
      ).then(res => {
        const data = res.data.data;
        this.pageParent.total = data.total;
        this.dataParent = data.records;
        this.loading = false;
        this.selectionClear();
      });
    },
    onLoadChild (page, params = {}) {
      this.loadingChild = true;
      getResourceChildList(
        page.currentPage,
        page.pageSize,
        this.parentId,
        Object.assign(params, this.query)
      ).then(res => {
        const data = res.data.data;
        this.dataChild = data;
        this.loadingChild = false;
        this.selectionClear();
      })
    },
    sortableChildChange (oldindex, newindex, row, list) {
      this.data = []
      this.$nextTick(() => {
        this.data = list;
      })
      this.sortIds = list.map((item) => item.id)
    }
  }
};
</script>
<style>
@media only screen and (min-width: 992px){
  .el-col-md-6 {
    width: 30%;
  }
}
.helpResourceConfig {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.leftBox {
  width: 50%;
}
.rightBox {
  flex: 1;
}
</style>